import React, { Fragment, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { API_BASE_URL } from "../../api/api";

export const ImageSlider = ({ images = [], mainImage = 0 }) => {
  const [state, setState] = useState({ nav1: null, nav2: null });
  const slider1 = useRef();
  const slider2 = useRef();

  useEffect(() => {
    setState({
      nav1: slider1.current,
      nav2: slider2.current,
    });
  }, []);

  const { nav1, nav2 } = state;

  if (!images || images.length === 0) {
    return (
      <div className="text-center my-4">
        <p>Este producto no tiene imágenes.</p>
      </div>
    );
  }

  return (
    <Fragment>
      {/* Slider principal */}
      <Slider
        asNavFor={nav2}
        className="product-slider mb-3"
        arrows={false}
        ref={(slider) => (slider1.current = slider)}
        initialSlide={mainImage}
      >
        {images.map((imageName, index) => (
          <div key={index}>
            <img
              src={`${API_BASE_URL}/product/get/file/${imageName}`}
              alt={`Imagen ${index + 1}`}
              style={{ width: "100%", maxHeight: 400, objectFit: "cover", borderRadius: 10 }}
            />
          </div>
        ))}
      </Slider>

      {/* Miniaturas */}
      <Slider
        asNavFor={nav1}
        ref={(slider) => (slider2.current = slider)}
        slidesToShow={4}
        swipeToSlide={true}
        focusOnSelect={true}
        infinite={false}
        className="small-slick"
      >
        {images.map((imageName, index) => (
          <div key={index} style={{ padding: 5 }}>
            <img
              src={`${API_BASE_URL}/product/get/file/${imageName}`}
              alt={`Thumb ${index + 1}`}
              style={{
                width: "100%",
                height: 80,
                objectFit: "cover",
                borderRadius: 6,
                border: index === mainImage ? "2px solid #7366FF" : "1px solid #ddd",
              }}
            />
          </div>
        ))}
      </Slider>
    </Fragment>
  );
};

export default ImageSlider;
